import { createEntityAdapter } from "@reduxjs/toolkit";

const adapter = createEntityAdapter();

export default adapter;
